// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 财联社快讯最新数量 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/article/express-count */
export async function clsArticleExpressCountUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsArticleExpressCountUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultint>('/cls/article/express-count', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 财联社文章详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/article/info */
export async function clsArticleInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsArticleInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultClsArticleInfoResp>('/cls/article/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 财联社文章列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/article/list */
export async function clsArticleListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsArticleListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsArticleInfoResp>('/cls/article/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 财联社推荐文章列表(热点/预警) # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/article/recommend-list */
export async function clsArticleRecommendListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsArticleRecommendListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsRecommendArticleResp>('/cls/article/recommend-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 财联社话题文章列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/article/subject-list */
export async function clsArticleSubjectListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsArticleSubjectListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsArticleInfoResp>('/cls/article/subject-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票公告详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/announce-info */
export async function clsStockAnnounceInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockAnnounceInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultClsStockAnnounceInfoResp>('/cls/stock/announce-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 自选股票公告列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/announce-list */
export async function clsStockAnnounceListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockAnnounceListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsStockAnnounceInfoResp>('/cls/stock/announce-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票公告列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/announce-list-by-stocks */
export async function clsStockAnnounceListByStocksUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockAnnounceListByStocksUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsStockAnnounceInfoResp>('/cls/stock/announce-list-by-stocks', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票新闻详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/news-info */
export async function clsStockNewsInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockNewsInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultClsStockNewsInfoResp>('/cls/stock/news-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 自选股票新闻列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/news-list */
export async function clsStockNewsListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockNewsListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsStockNewsInfoResp>('/cls/stock/news-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票新闻列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/news-list-by-stocks */
export async function clsStockNewsListByStocksUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockNewsListByStocksUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsStockNewsInfoResp>('/cls/stock/news-list-by-stocks', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 财联社大涨股列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/plate-list */
export async function clsStockPlateListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockPlateListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsStockPlateResp>('/cls/stock/plate-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票研报详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/research-info */
export async function clsStockResearchInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockResearchInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultClsStockResearchInfoResp>('/cls/stock/research-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 自选股票研报列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/research-list */
export async function clsStockResearchListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockResearchListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsStockResearchInfoResp>('/cls/stock/research-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票研报列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /cls/stock/research-list-by-stocks */
export async function clsStockResearchListByStocksUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.clsStockResearchListByStocksUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListClsStockResearchInfoResp>('/cls/stock/research-list-by-stocks', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
